import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';

export default function ScappVersionSelector({ dashboardVersion = 'v1', onChange }) {
  return (
    <Box sx={{ px: 2, py: 1 }}>
      <FormControl fullWidth size="small">
        <InputLabel id="scapp-version-label" sx={{ color: '#b8c1ce' }}>
          Versión de SCAPP
        </InputLabel>
        <Select
          labelId="scapp-version-label"
          label="Versión de SCAPP"
          value={dashboardVersion === 'v2' ? 'v2' : 'v1'}
          sx={{
            color: '#f3f5f8',
            '& fieldset': { borderColor: 'rgba(232,78,14,.5)' },
            '& .MuiSelect-icon': { color: '#b8c1ce' },
          }}
          onChange={(event) => onChange?.(event.target.value)}
        >
          <MenuItem value="v1">Versión 1 · Anterior</MenuItem>
          <MenuItem value="v2">Versión 2 · Panel de jaulas</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
